export default function useFormatedNumber() {

  function toArabicNumber(num) {
    const zero = 1632;
    let numberString = '' + num;
    let arabicNumber = '';

    for(let i=0; i<numberString.length; i++) {
      arabicNumber += String.fromCharCode(zero + parseInt(numberString[i]));
    }
    return arabicNumber;
  }

  function printNumber(number, numberSystem = 'arabic') {
    if(numberSystem === 'indian') {
      return toArabicNumber(number);
    } else {
      return number;
    }
  }

  return printNumber;
};
